import {
  createSet,
  deleteSet,
  getAllSets,
  getPublicSetById,
  getSetById,
  getMySetById,
  getSetsStatistics,
  getFeaturedSets,
  updateSet,
  exportSets,
  importSets,
} from "./asyncThunk";

export const getAllSetsBuilder = (builder) => {
  builder.addCase(getAllSets.pending, (state) => {
    state.loading.getAllSets = true;
    state.errors.getAllSets = null;
  });
  builder.addCase(getAllSets.fulfilled, (state, action) => {
    state.loading.getAllSets = false;
    state.sets = action.payload.data.sets;
    state.pagination = {
      page: action.payload.data.page,
      limit: action.payload.data.limit,
      total: action.payload.data.total,
      totalPages: action.payload.data.totalPages,
    };
  });
  builder.addCase(getAllSets.rejected, (state, action) => {
    state.loading.getAllSets = false;
    state.errors.getAllSets = action.payload;
  });
};

export const getFeaturedSetsBuilder = (builder) => {
  builder.addCase(getFeaturedSets.pending, (state) => {
    state.loading.getFeaturedSets = true;
    state.errors.getFeaturedSets = null;
  });

  builder.addCase(getFeaturedSets.fulfilled, (state, action) => {
    state.loading.getFeaturedSets = false;
    state.featuredSets = action.payload.data.sets;
  });

  builder.addCase(getFeaturedSets.rejected, (state, action) => {
    state.loading.getFeaturedSets = false;
    state.errors.getFeaturedSets = action.payload;
  });
};

export const getPublicSetByIdBuilder = (builder) => {
  builder.addCase(getPublicSetById.pending, (state) => {
    state.loading.getSetById = true;
    state.errors.getSetById = null;
  });
  builder.addCase(getPublicSetById.fulfilled, (state, action) => {
    state.loading.getSetById = false;
    state.selectedSet = action.payload.data.set;
  });
  builder.addCase(getPublicSetById.rejected, (state, action) => {
    state.loading.getSetById = false;
    state.errors.getSetById = action.payload;
  });
};

export const getSetByIdBuilder = (builder) => {
  builder.addCase(getSetById.pending, (state) => {
    state.loading.getSetById = true;
    state.errors.getSetById = null;
  });
  builder.addCase(getSetById.fulfilled, (state, action) => {
    state.loading.getSetById = false;
    state.selectedSet = action.payload.data.set;
  });
  builder.addCase(getSetById.rejected, (state, action) => {
    state.loading.getSetById = false;
    state.errors.getSetById = action.payload;
  });
};

export const getMySetByIdBuilder = (builder) => {
  builder.addCase(getMySetById.pending, (state) => {
    state.loading.getMySetById = true;
    state.errors.getMySetById = null;
  });
  builder.addCase(getMySetById.fulfilled, (state, action) => {
    state.loading.getMySetById = false;
    state.selectedSet = action.payload.data.set;
  });
  builder.addCase(getMySetById.rejected, (state, action) => {
    state.loading.getMySetById = false;
    state.errors.getMySetById = action.payload;
  });
};

export const createSetBuilder = (builder) => {
  builder.addCase(createSet.pending, (state) => {
    state.loading.createSet = true;
    state.errors.createSet = null;
  });
  builder.addCase(createSet.fulfilled, (state, action) => {
    state.loading.createSet = false;
    state.sets.unshift(action.payload.data.set);
    state.pagination.total += 1;
  });
  builder.addCase(createSet.rejected, (state, action) => {
    state.loading.createSet = false;
    state.errors.createSet = action.payload;
  });
};

export const updateSetBuilder = (builder) => {
  builder.addCase(updateSet.pending, (state) => {
    state.loading.updateSet = true;
    state.errors.updateSet = null;
  });
  builder.addCase(updateSet.fulfilled, (state, action) => {
    state.loading.updateSet = false;
    const updatedSet = action.payload.data.set;
    const index = state.sets.findIndex((set) => set.id === updatedSet.id);
    if (index !== -1) {
      state.sets[index] = updatedSet;
    }
    if (state.selectedSet && state.selectedSet.id === updatedSet.id) {
      state.selectedSet = updatedSet;
    }
  });
  builder.addCase(updateSet.rejected, (state, action) => {
    state.loading.updateSet = false;
    state.errors.updateSet = action.payload;
  });
};

export const deleteSetBuilder = (builder) => {
  builder.addCase(deleteSet.pending, (state) => {
    state.loading.deleteSet = true;
    state.errors.deleteSet = null;
  });
  builder.addCase(deleteSet.fulfilled, (state, action) => {
    state.loading.deleteSet = false;
    const deletedId = action.payload.data.setId;
    state.sets = state.sets.filter((set) => set.id !== deletedId);
    state.pagination.total -= 1;
    if (state.selectedSet && state.selectedSet.id === deletedId) {
      state.selectedSet = null;
    }
  });
  builder.addCase(deleteSet.rejected, (state, action) => {
    state.loading.deleteSet = false;
    state.errors.deleteSet = action.payload;
  });
};

export const getSetsStatisticsBuilder = (builder) => {
  builder.addCase(getSetsStatistics.pending, (state) => {
    state.loading.getSetsStatistics = true;
    state.errors.getSetsStatistics = null;
  });
  builder.addCase(getSetsStatistics.fulfilled, (state, action) => {
    state.loading.getSetsStatistics = false;
    state.statistics = action.payload.data.statistics;
  });
  builder.addCase(getSetsStatistics.rejected, (state, action) => {
    state.loading.getSetsStatistics = false;
    state.errors.getSetsStatistics = action.payload;
  });
};

export const exportSetsBuilder = (builder) => {
  builder.addCase(exportSets.pending, (state) => {
    state.loading.exportSets = true;
    state.errors.exportSets = null;
  });
  builder.addCase(exportSets.fulfilled, (state, action) => {
    state.loading.exportSets = false;
  });
  builder.addCase(exportSets.rejected, (state, action) => {
    state.loading.exportSets = false;
    state.errors.exportSets = action.payload;
  });
};

export const importSetsBuilder = (builder) => {
  builder.addCase(importSets.pending, (state) => {
    state.loading.importSets = true;
    state.errors.importSets = null;
  });
  builder.addCase(importSets.fulfilled, (state, action) => {
    state.loading.importSets = false;
    if (action.payload.data.imported && action.payload.data.imported.length > 0) {
      state.sets.unshift(...action.payload.data.imported);
      state.pagination.total += action.payload.data.imported.length;
    }
  });
  builder.addCase(importSets.rejected, (state, action) => {
    state.loading.importSets = false;
    state.errors.importSets = action.payload;
  });
};
